<template>
    <quote-chat-messages-modal
        v-if="quoteKey"
        :key="quoteKey"
        :quote-key="quoteKey"
        :is-customer="false"
        v-model="open"
    ></quote-chat-messages-modal>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref, watch } from "vue";
const quoteKey = ref(null);
const open = ref(false);
function handleOpen(event) {
    const requestedQuoteKey = event.detail?.quoteKey;
    if (!requestedQuoteKey) {
        return;
    }
    event.preventDefault();
    quoteKey.value = requestedQuoteKey;
    open.value = true;
}
watch(open, (isOpen) => {
    if (isOpen || !quoteKey.value) {
        return;
    }
    window.dispatchEvent(
        new CustomEvent("ChatModalClosed", {
            detail: { quoteKey: quoteKey.value },
        })
    );
});
onMounted(() => {
    window.addEventListener("ChatModalOpen", handleOpen);
});
onBeforeUnmount(() => {
    window.removeEventListener("ChatModalOpen", handleOpen);
});
</script>
